<template>
  <div>
    <h4
      class="text-center display-1 mt-6 font-weight-light darken-1"
      style="color: #5757ff"
      giveMeATour-v-step="7"
    >
      Create New Mission
    </h4>
    <v-col cols="8" offset="2" align-self="center" id="missions" text-xs-center>
      <div class="subtitle grey--text darken-2">
        <h5 class="headline p-3 mb-5 font-weight-light">
          <span>Modules</span>
        </h5>
      </div>
      <v-row>
        <v-expansion-panels>
          <v-expansion-panel v-for="mode in getModes()" :key="mode.type">
            <v-expansion-panel-header>
              <v-col cols="6">
                <v-row>
                  <div class="ml-5 text-left title">{{ mode.text }}</div>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row class="mr-5" justify="end">
                  <div
                    v-if="
                      !isParametricStudies(mode.text) &&
                      !isConstellationModule(mode.text)
                    "
                  >
                    <v-btn
                      depressed
                      large
                      @click.native.stop="setModule(mode.type)"
                      color="primary"
                      ref="btn"
                      :id="'moduleBtn-' + mode.type"
                      >Select</v-btn
                    >
                  </div>
                  <div v-if="isParametricStudies(mode.text)">
                    <v-btn
                      depressed
                      large
                      @click.native.stop="setModule(mode.type)"
                      color="primary"
                      giveMeATour-v-step="8"
                      gt_ParamOrbitTransfert1-v-step="1"
                      ref="btnParamStudies"
                      :id="'moduleBtn-' + mode.type"
                      >Select</v-btn
                    >
                  </div>
                  <div v-if="isConstellationModule(mode.text)">
                    <v-btn
                      depressed
                      large
                      @click.native.stop="setModule(mode.type)"
                      color="primary"
                      gt_PerformanceAnalysis-v-step="1"
                      ref="btnConstellation"
                      :id="'moduleBtn-' + mode.type"
                      >Select</v-btn
                    >
                  </div>
                </v-row>
              </v-col>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ml-4">
              <v-row slot="header" align-center>
                <v-col cols="9">
                  <h5>{{ mode.text }}</h5>
                </v-col>
                <v-col> </v-col>
              </v-row>
              <v-card-text class="text-left pt-0 px-4 grow">
                <v-row style="margin-bottom: 5px">
                  <span style="color: #5757ff" class="p-2 body-1 mb-1"
                    >Missions</span
                  >
                </v-row>
                <v-row
                  no-gutters
                  v-for="mission in getMissionTypes(mode.type)"
                  :key="mission.title"
                >
                  <i class="material-icons success--text subheading"> done </i>
                  <p class="font-weight-light caption ma-0 pl-1">
                    {{ mission.title }}
                  </p>
                </v-row>
                <v-row style="margin-bottom: 5px">
                  <span style="color: #5757ff" class="p-2 body-1 mb-1 mt-1"
                    >Configuration</span
                  >
                </v-row>
                <v-row
                  no-gutters
                  v-for="conf in getModeConfiguration(mode.type)"
                  :key="conf.text"
                >
                  <i class="material-icons success--text subheading">
                    {{ conf.icon }}
                  </i>
                  <p class="font-weight-light caption ma-0 pl-1">
                    {{ conf.text }}
                  </p>
                </v-row>
                <v-row style="margin-bottom: 5px">
                  <span style="color: #5757ff" class="p-2 body-1 mb-1 mt-1"
                    >Results</span
                  >
                </v-row>
                <v-row
                  no-gutters
                  v-for="result in getModeResults(mode.type)"
                  :key="result.text"
                >
                  <i class="material-icons success--text subheading">
                    {{ result.icon }}
                  </i>
                  <p class="font-weight-light caption ma-0 pl-1">
                    {{ result.text }}
                  </p>
                </v-row>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-col>
    <v-col
      cols="10"
      offset="1"
      align-self="center"
      id="missions"
      text-xs-center
    >
      <div v-if="module" class="text-center">
        <div class="subtitle grey--text darken-2">
          <h5 class="headline p-3 ma-3 font-weight-light">
            <span id="mission-type-header">Mission Type</span>
          </h5>
        </div>
        <v-row>
          <v-col cols="4" v-for="mission in missionTypes" :key="mission.title">
            <v-hover>
              <!-- WARNING: CUSTOM BACKGROUND COLOR BECAUSE OF DARK MODE MOTION DESIGNS -->
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                height="100%"
                :color="$vuetify.theme.dark ? '#2a2a2a' : ''"
              >
                <v-row justify="center" no-gutters class="fill-height">
                  <v-card-title class="ma-0">
                    <h5 class="ma-0">
                      {{ mission.title }}

                      <sup v-if="mission.beta === true" class="orange--text"
                        >BETA</sup
                      >
                      <v-tooltip bottom v-if="mission.beta === true">
                        <template v-slot:activator="{ on }">
                          <v-img
                            v-on="on"
                            :src="
                              require('../assets/images/logo-chemistry.png')
                            "
                            height="40"
                            contain
                          />
                        </template>
                        <span
                          >This feature is experimental and will be improved
                          soon</span
                        >
                      </v-tooltip>
                    </h5>
                  </v-card-title>

                  <v-card-text class="text-left grow p-0">
                    <v-divider class="m-0"></v-divider>
                    <v-img
                      v-if="mission.img.includes('.png')"
                      contain
                      :src="require('../assets/images/' + mission.img)"
                      aspect-ratio="2"
                    />
                    <v-row v-if="mission.img.includes('.mp4')" justify="center">
                      <video
                        v-if="$vuetify.theme.dark"
                        autoplay
                        loop
                        muted
                        playsinline
                        disablePictureInPicture
                        style="width: 70%"
                      >
                        <source
                          :src="require('../assets/videos/dark' + mission.img)"
                          type="video/mp4"
                        />
                      </video>
                      <video
                        v-if="!$vuetify.theme.dark"
                        autoplay
                        loop
                        muted
                        playsinline
                        disablePictureInPicture
                        style="width: 70%"
                      >
                        <source
                          :src="require('../assets/videos/light' + mission.img)"
                          type="video/mp4"
                        />
                      </video>
                    </v-row>
                    <v-divider class="m-0"></v-divider>
                    <div
                      class="font-weight-light ml-2 mt-2"
                      giveMeATour-v-step="9"
                    >
                      {{ mission.text }}
                    </div>
                    <v-row v-if="mission.beta === true" class="mt-2">
                      <v-col>
                        <v-img
                          :src="require('../assets/images/logo-chemistry.png')"
                          height="40"
                          width="40"
                        />
                      </v-col>
                      <v-col cols="10">
                        <div class="font-weight-light orange--text">
                          We are currently experimenting with this mission to
                          improve it. Please let us know if you find some odd
                          results.
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-col>
                    <v-row
                      class="fill-height"
                      no-gutters
                      justify="center"
                      align="end"
                    >
                      <v-card-actions>
                        <v-col v-if="disableNotActivated(mission)">
                          <i>Option not activated, upgrade your account.</i>
                        </v-col>
                        <v-col v-if="!mission.type.includes('Constellation')">
                          <v-btn
                            v-if="missionIsParamOrbitTransfer(mission.title)"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="setMissionType(mission.type)"
                            gt_ParamOrbitTransfert1-v-step="2"
                            ref="orbitTransferBtn"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                          <v-btn
                            v-if="
                              mission.title !== 'Evasive Maneuver' &&
                              mission.title !== 'Screening' &&
                              mission.title !== 'Data Generator' &&
                              !missionIsParamOrbitTransfer(mission.title) &&
                              mission.title !== 'Simulator' &&
                              mission.title !== 'Maneuver Restitution' &&
                              mission.title !== 'Maneuver Analysis'
                            "
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="setMissionType(mission.type)"
                            ref="missionBtn"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                          <!-- <v-btn
                            v-if="mission.title === 'Simulator'"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToSimulator()"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                          <v-btn
                            v-if="mission.title === 'Maneuver Restitution'"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToManeuverRestitution()"
                            >Select</v-btn
                          > -->
                          <v-btn
                            v-if="mission.title === 'Maneuver Analysis'"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToManeuverAnalysis()"
                            >Select</v-btn
                          >
                          <v-btn
                            v-if="mission.title === 'Data Generator'"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToDataGenerator()"
                            >Select</v-btn
                          >
                          <v-btn
                            v-if="mission.title === 'Screening'"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToScreeningCatalogueAnalysis()"
                            >Select</v-btn
                          >
                          <v-btn
                            v-if="mission.title === 'Evasive Maneuver'"
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToEvasiveManeuver()"
                            >Select</v-btn
                          >
                        </v-col>
                        <v-col v-if="mission.title === 'Performance Analysis'">
                          <v-btn
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            gt_PerformanceAnalysis-v-step="2"
                            ref="performanceAnalysisBtn"
                            v-on:click="redirectToConstellation()"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                        </v-col>
                        <v-col v-if="mission.title === 'Optimization'">
                          <v-btn
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToConstellationOptimization()"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                        </v-col>
                        <v-col v-if="mission.title === 'Generation'">
                          <v-btn
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToConstellationGeneration()"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                        </v-col>
                        <v-col v-if="mission.title === 'Simulation'">
                          <v-btn
                            :disabled="disableNotActivated(mission)"
                            small
                            depressed
                            color="primary"
                            v-on:click="redirectToNumericalConstellation()"
                            :id="'missionBtn-' + mission.id"
                            >Select</v-btn
                          >
                        </v-col>
                      </v-card-actions>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-tour
      name="newMissionTour"
      :steps="steps"
      :callbacks="customTourCallbacks"
    ></v-tour>
    <v-tour
      name="paramOrbitalTransfer1TourNewMission"
      :steps="steps_create_mission"
      :callbacks="customTourCallbacks"
    ></v-tour>
    <v-tour
      name="performanceAnalysisTourNewMission"
      :steps="steps_create_mission_perf_analysis"
      :callbacks="customTourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import missionTools from '../store/mission.js'
import dataTools from '../tools/data.js'
import guidedTutorialParamOrbitalTransfer1, {
  steps_create_mission
} from '../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import guidedTutorialPerformanceAnalysis, {
  steps_create_mission_perf_analysis
} from '../components/GuidedTutorials/guidedTutorialPerformanceAnalysis.js'

export default {
  name: 'CreateMission',

  data() {
    const self = this
    return {
      expandedPanelIndex: -1,
      module: null,
      missionType: null,
      missionTypes: null,
      modeConfiguration: null,
      modeResults: null,
      steps: [
        {
          target: '[giveMeATour-v-step="7"]',
          content: 'Create a <strong>new mission</strong> from this page.'
        },
        {
          target: '[giveMeATour-v-step="8"]',
          content:
            'Discover all the missions you can create for each <strong>module</strong>.'
        },
        {
          target: '[giveMeATour-v-step="9"]',
          content:
            'All the missions have a <strong>description</strong> associated that gives further details on the mission.'
        }
      ],
      steps_create_mission: steps_create_mission,
      steps_create_mission_perf_analysis: steps_create_mission_perf_analysis,
      customTourCallbacks: {
        onNextStep: (currentStep) => {
          if (currentStep === 0) {
            if (this.gt_OrbitTransferParam1.isActive) {
              self.$refs.btnParamStudies[0].$el.click()
            } else if (this.gt_PerformanceAnalysis.isActive) {
              self.$refs.btnConstellation[0].$el.click()
            }
          }
          if (currentStep === 1 && this.giveMeATour) {
            self.$refs.btnParamStudies[0].$el.click()
          }
        },
        onSkip: () => {
          if (this.gt_OrbitTransferParam1.isActive) {
            guidedTutorialParamOrbitalTransfer1.onSkipCreateMission(this)
          } else if (this.gt_PerformanceAnalysis.isActive) {
            guidedTutorialPerformanceAnalysis.onSkipCreateMission(this)
          } else if (this.giveMeATour) {
            if (self.$refs.orbitTransferBtn != null) {
              console.log('play')
              self.$refs.orbitTransferBtn[0].$el.click()
            } else {
              this.redirectToMissionSetting('ParametricStudyRequest')
              let mission = {
                type: 'Orbital Transfer',
                typeName: 'ParametricStudyRequest'
              }
              this.sendMissionEvent('create-mission', mission)
            }
          }
        },
        onFinish: () => {
          if (this.giveMeATour) {
            self.$refs.orbitTransferBtn[0].$el.click()
          } else if (
            this.gt_OrbitTransferParam1.isActive &&
            self.$refs.orbitTransferBtn != null
          ) {
            self.$refs.orbitTransferBtn[0].$el.click()
          } else if (
            this.gt_PerformanceAnalysis.isActive &&
            self.$refs.performanceAnalysisBtn != null
          ) {
            self.$refs.performanceAnalysisBtn[0].$el.click()
          }
        }
      }
    }
  },

  mounted() {
    this.$root.$emit('set-current-mission', null)
    if (this.giveMeATour) {
      this.$tours['newMissionTour'].start()
    }
    if (this.gt_OrbitTransferParam1.isActive) {
      this.$tours['paramOrbitalTransfer1TourNewMission'].start()
    }
    if (this.gt_PerformanceAnalysis.isActive) {
      this.$tours['performanceAnalysisTourNewMission'].start()
    }
  },

  watch: {
    'gt_OrbitTransferParam1.isActive'(val) {
      if (this.gt_OrbitTransferParam1.isActive) {
        this.$tours['paramOrbitalTransfer1TourMissions'].start()
      }
    },
    'gt_PerformanceAnalysis.isActive'(val) {
      if (this.gt_PerformanceAnalysis.isActive) {
        this.$tours['performanceAnalysisTourNewMission'].start()
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      giveMeATour: 'giveMeATour',
      gt_OrbitTransferParam1: 'gt_OrbitTransferParam1',
      gt_PerformanceAnalysis: 'gt_PerformanceAnalysis'
    })
  },

  methods: {
    isParametricStudies(mode) {
      return mode === 'Parametric Studies'
    },

    isConstellationModule(mode) {
      return mode === 'Constellations'
    },

    missionIsParamOrbitTransfer(mission) {
      return mission === 'Orbital Transfer'
    },

    getModes() {
      let modes = [
        { type: 'Constellations', text: 'Constellations' },
        { type: 'Deployment', text: 'Deployment Strategies' },
        { type: 'Analytical', text: 'Parametric Studies' },
        { type: 'Numerical', text: 'Simulations' }
      ]
      let defenseActivated = missionTools.isModuleEnabled(
        'DEFENSE',
        this.currentUser.options
      )
      let asterxActivated = missionTools.isModuleEnabled(
        'ASTERX',
        this.currentUser.options
      )
      if (defenseActivated) {
        modes.push({ type: 'Defense', text: 'Defense' })
      }
      if (asterxActivated) {
        modes.push({ type: 'AsterX', text: 'AsterX' })
      }
      return modes
    },

    setModule(module) {
      this.module = module
      this.missionTypes = this.getMissionTypes(module)
      try {
        this.$vuetify.goTo('#mission-type-header', {
          duration: 500,
          easing: 'easeInOutQuad'
        })
      } catch {}
    },
    setMissionType(type) {
      this.missionType = type
      this.createNewMission()
    },
    getMissionTypes(module) {
      if (module === 'Analytical') {
        let missions = [
          {
            module: module,
            type: 'Orbital Transfer',
            img: '-motion-orbital-transfer.mp4',
            text: 'Simultaneous semi-major axis and inclination changes. Change the orbital plane of your spacecraft after the launch.',
            id: 'analytical-orbital-transfer'
          },
          {
            module: module,
            type: 'Orbit Phasing',
            img: '-motion-orbit-phasing.mp4',
            text: 'Optimise the distribution of your spacecrafts with phasing manoeuvres within a single plane.',
            id: 'analytical-orbit-phasing'
          },
          {
            module: module,
            img: '-motion-raan-phasing.mp4',
            type: 'RAAN Phasing',
            text: 'Optimised relative phasing of the Right Ascension of the Ascending Node (RAAN). The optimisation can be performed with a final orbital plane different from the initial one, thus combining changes on semi-major axis, inclination and RAAN at the same time to deploy your constellation.',
            id: 'analytical-raan-phasing'
          },
          {
            module: module,
            type: 'LEO Station Keeping',
            img: '-motion-leo-station-keeping.mp4',
            text: 'Propulsion can be used to compensate atmospheric drag in Low Earth Orbit (LEO). Add a few years of lifetime to your constellation, and develop new high downlink/high picture resolution missions in Very Low Earth Orbit (VLEO).',
            id: 'analytical-leo-station-keeping'
          },
          {
            module: module,
            img: '-motion-deorbiting.mp4',
            type: 'Deorbitation',
            text: 'Deorbit your spacecraft at the end of its mission to prevent further space pollution.',
            id: 'analytical-deorbitation'
          },
          {
            module: module,
            type: 'Sequence',
            img: '-motion-sequence.mp4',
            text: 'Combine all the missions you want to simulate the whole life of your spacecraft, from launch to deorbitation.',
            id: 'analytical-sequence'
          },
          {
            module: module,
            type: 'ADCS Design',
            img: '-motion-adcs-design.mp4',
            text: 'Carry out a preliminary design of the ADCS (Attitude Dynamics Control Systems) of a spacecraft subject to perturbations including drag, solar radiation pressure, residual magnetic moment and a misalignment between its centre of gravity and the thrust direction of its propulsion system.',
            id: 'analytical-adcs-design'
          }
          /*, beta: true */
        ]
        this.updateMissionsTitles('ParametricStudyRequest', missions)
        return missions
      } else if (module === 'Numerical') {
        let missions = [
          {
            module: module,
            type: 'Orbital Transfer',
            img: '-motion-orbital-transfer.mp4',
            text: 'Simultaneous semi-major axis and inclination changes. Change the orbital plane of your spacecraft after the launch.',
            id: 'numerical-orbital-transfer'
          },
          {
            module: module,
            type: 'Orbit Phasing',
            img: '-motion-orbit-phasing.mp4',
            text: 'Optimise the repartition of your spacecrafts with phasing manoeuvres within a single plane.',
            id: 'numerical-orbit-phasing'
          },
          {
            module: module,
            type: 'RAAN Phasing',
            img: '-motion-raan-phasing.mp4',
            text: 'Optimised relative phasing of the Right Ascension of the Ascending Node (RAAN). The optimisation can be performed with a final orbital plane different from the initial one, thus combining changes on semi-major axis, inclination and RAAN at the same time to deploy your constellation.',
            id: 'numerical-raan-phasing'
          },
          {
            module: module,
            type: 'LEO Station Keeping',
            img: '-motion-leo-station-keeping.mp4',
            text: 'Counteract the effects of orbital perturbations through periodic maneuvers.',
            id: 'numerical-leo-station-keeping',
            beta: true
          },
          {
            module: module,
            type: 'Maneuvering Strategy Design',
            img: '-motion-spacecraft-design-analysis.mp4',
            text: 'Spacecraft power-budget evaluation depending on attitude and orbit. Obtain information to tune your propulsion system in order to thrust more efficiently.',
            id: 'numerical-maneuvering-strategy-design'
          },
          {
            module: module,
            type: 'Orbit Extrapolation',
            img: '-motion-leo-station-keeping.mp4',
            text: 'Simulate the natural evolution of the spacecraft orbit under the influence of perturbations.',
            id: 'numerical-orbit-extrapolation'
          }
        ]
        this.updateMissionsTitles('SimulationRequest', missions)
        return missions
      } else if (module === 'Constellations') {
        return [
          {
            module: module,
            title: 'Performance Analysis',
            type: 'Constellation',
            img: '-motion-constellation-performance-analysis.mp4',
            text: 'Analyse the performances of a constellation in terms of revisit rate, coverage and interactions with a ground segment.',
            id: 'constellations-performance-analysis'
          },
          {
            module: module,
            title: 'Optimization',
            type: 'Constellation Optimization',
            img: '-motion-constellation-optimisation.mp4',
            text: 'Optimise the revisits performances of a constellation under maneuver constraints.',
            id: 'constellations-optimization'
          },
          {
            module: module,
            title: 'Generation',
            type: 'Constellation Generation',
            img: '-motion-constellation-generation.mp4',
            text: 'Generate a suitable constellation from geometrical considerations on points of interest coverage by a defined payload.',
            id: 'constellations-generation'
          },
          {
            module: module,
            title: 'Simulation',
            type: 'NumericalConstellation',
            img: '-motion-constellation-simulation.mp4',
            text: 'The constellation simulation mission computes the ephemerides of each spacecraft of a constellation, thanks to precise numerical propagation. These ephemerides are used to build timelines of visibility events concerning spacecrafts, points of interest and ground stations.',
            id: 'constellations-simulation'
          }
        ]
      } else if (module === 'Deployment') {
        return [
          {
            module: module,
            title: 'Deployment Scenario',
            type: 'Deployment Scenario',
            img: '-motion-deployment-scenario.mp4',
            text: 'Compute relevant metrics on the deployment of a constellation, given a launch sequence.',
            id: 'deployment-scenario'
          },
          {
            module: module,
            title: 'Deployment Optimization',
            type: 'Deployment Optimization',
            img: '-motion-deployment-optimisation.mp4',
            text: 'Define a constellation and launch constraints in order to find an optimal deployment strategy.',
            id: 'deployment-optimization'
          }
        ]
      } else if (module === 'Defense') {
        return [
          // { see issue #198 in defense
          //   module: module,
          //   title: 'Simulator',
          //   type: 'Simulator',
          //   img: '-motion-constellation-simulation.mp4',
          //   text: 'Simule des données radar',
          //   id: 'defense-simulator'
          // },
          // { see issue #198 in defense
          //   module: module,
          //   title: 'Maneuver Restitution',
          //   type: 'Maneuver Restitution',
          //   img: '-motion-leo-station-keeping.mp4',
          //   text: 'Restitue les caractéristiques d’une manœuvre sur la base d’un ensemble de données.'
          // },
          {
            module: module,
            title: 'Maneuver Analysis',
            type: 'Maneuver Analysis',
            img: '-motion-orbital-transfer.mp4',
            text: 'Detect and analyse maneuvers from a SP ephemeris files database.'
          },
          {
            module: module,
            title: 'Data Generator',
            type: 'Data Generator',
            img: '-motion-constellation-simulation.mp4',
            text: 'Simulate a sequence of maneuvers and generate the associated ephemeris data.'
          },
          {
            module: module,
            title: 'Screening',
            type: 'Screening',
            img: '-motion-constellation-performance-analysis.mp4',
            text: 'Perform event screening on a TLE catalogue (maneuvers, conjunctions, ...)'
          }
        ]
      } else if (module === 'AsterX') {
        return [
          {
            module: module,
            title: 'Evasive Maneuver',
            type: 'Evasive Maneuver',
            img: '-motion-orbital-transfer.mp4',
            text: 'Design and trade-off evasive maneuvers from a detected future conjunction or RPO.'
          }
        ]
      }
    },

    updateMissionsTitles(missionClass, missions) {
      for (let mission of missions) {
        const label = dataTools.getTypeLabel(missionClass, mission.type)
        mission.title = label
      }
    },

    getModeConfiguration(module) {
      if (module === 'Analytical') {
        return [
          { text: 'Parametric computations', icon: 'done' },
          {
            text: 'Simplified orbit definition: circular orbits defined from altitude and inclination',
            icon: 'done'
          },
          { text: 'Compare different propulsion systems', icon: 'done' },
          { text: 'Duty cycle and burn strategies', icon: 'done' }
        ]
      } else if (module === 'Numerical') {
        return [
          { text: 'Orbit definition from 6 orbital elements', icon: 'done' },
          {
            text: 'Spacecraft model with shape, battery and solar panels',
            icon: 'done'
          },
          { text: 'Numerical propagation: time tagged', icon: 'done' },
          {
            text: 'Semi-analytical propagation: fast, but averaged',
            icon: 'done'
          },
          {
            text: 'Perturbations: Earth potential, drag, solar radiation pressure, third body (Sun, Moon)',
            icon: 'done'
          }
        ]
      } else if (module === 'Constellations') {
        return [
          {
            text: 'Constellation geometries including Walker-Delta, Walker-Star as well as user-defined patterns',
            icon: 'done'
          },
          {
            text: 'Rectangular Earth meshing on which to compute constellation performances',
            icon: 'done'
          },
          {
            text: 'Payloads defined by the geometrical properties of their field of regard (swath, minimum elevevation...)',
            icon: 'done'
          },
          {
            text: 'Ground stations defined by their geographical coordinates and the minimum elevation of their field of view',
            icon: 'done'
          }
        ]
      } else if (module === 'Deployment') {
        return [
          { text: 'Dedicated and rideshare launches', icon: 'done' },
          { text: 'Definition of launch sequences', icon: 'done' }
        ]
      } else if (module === 'Defense') {
        return [
          { text: 'SP ephemeris data management', icon: 'done' },
          {
            text: 'Space object definition from thrust, specific impulse and mass',
            icon: 'done'
          },
          { text: 'Spherical spacecraft shape', icon: 'done' },
          {
            text: 'Orbit determination for ballistic segments analysis',
            icon: 'done'
          }
        ]
      } else if (module === 'AsterX') {
        return [
          {
            text: 'Space object definition from thrust, specific impulse and mass',
            icon: 'done'
          },
          { text: 'Spherical spacecraft shape', icon: 'done' }
        ]
      }
    },
    getModeResults(module) {
      if (module === 'Analytical') {
        return [
          { text: 'Fast analytical computations', icon: 'done' },
          {
            text: 'Estimate ∆V, propellant consumption and mission duration',
            icon: 'done'
          },
          { text: 'Estimate number of burns and burns duration', icon: 'done' },
          { text: 'Overview of mission-specific results', icon: 'done' },
          {
            text: 'Built-in cost functions to link technological and mission choices to missions costs',
            icon: 'done'
          },
          {
            text: 'Plot parametric results: multi axis, contour/heat map, bar chart',
            icon: 'done'
          },
          { text: 'Export data to .csv format', icon: 'done' }
        ]
      } else if (module === 'Numerical') {
        return [
          {
            text: 'Accurate ∆v, propellant consumption and mission duration',
            icon: 'done'
          },
          { text: 'Accurate burn statistics', icon: 'done' },
          {
            text: 'Full state ephemerides: position, battery, thrust direction, attitude...',
            icon: 'done'
          },
          { text: 'Plot ephemerides', icon: 'done' },
          { text: '3D view of the spacecraft trajectory', icon: 'done' },
          { text: 'Export ephemerides to .csv file', icon: 'done' }
        ]
      } else if (module === 'Constellations') {
        return [
          { text: 'Fast analytical algorithms', icon: 'done' },
          {
            text: 'Revisit statistics (per point of interest): access duration, revisit time, collect time, number of accesses, number of spacecrafts simultaneously seen',
            icon: 'done'
          },
          {
            text: 'Ground segment statistics: forward link transfer time, reverse link transfer time, forward to reverse link time, time between reverse link arrivals',
            icon: 'done'
          },
          {
            text: 'Iterate on the design choices and perform trade offs between different coverage patterns',
            icon: 'done'
          },
          { text: 'Export results to .csv file', icon: 'done' }
        ]
      } else if (module === 'Deployment') {
        return [
          {
            text: 'Fast analytical computation of the metrics for a launch sequence: ∆V, date of exploitation of the constellation, cost...',
            icon: 'done'
          },
          { text: 'Compare different launch strategies', icon: 'done' }
        ]
      } else if (module === 'Defense') {
        return [
          {
            text: 'Detected maneuvers characteristics (∆a, ∆i, ∆e) and maneuver cost (∆v, ∆m, ...)',
            icon: 'done'
          },
          {
            text: 'Space object ballistic coefficient estimation between maneuvers',
            icon: 'done'
          },
          { text: 'Maximum maneuvers reports', icon: 'done' },
          {
            text: 'Unusual or noteworthy events from a TLE catalogue.',
            icon: 'done'
          }
        ]
      } else if (module === 'AsterX') {
        return [
          {
            text: 'Evasive maneuvers propositions.',
            icon: 'done'
          }
        ]
      }
    },

    disableNotActivated(mission) {
      return !missionTools.isMissionEnabled(
        mission.module,
        mission.type,
        this.currentUser.options
      )
    },

    // TODO: code from Missio.vue => create a manager or library to avoid duplicate code
    redirectToConstellation() {
      this.$router.push({ path: '/analyticalconstellationsimulation' })
      this.sendMissionEvent('create-mission', {
        typeName: 'ConstellationPerformanceAnalysisRequest'
      })
    },
    redirectToConstellationOptimization() {
      this.$router.push({ path: '/constellationrevisitoptimizationmission' })
      this.sendMissionEvent('create-mission', {
        typeName: 'ConstellationOptimizationRequest'
      })
    },
    redirectToConstellationGeneration() {
      this.$router.push({ path: '/constellationgenerationmission' })
      this.sendMissionEvent('create-mission', {
        typeName: 'ConstellationGenerationRequest'
      })
    },
    redirectToNumericalConstellation() {
      this.$router.push({ path: '/numericalconstellationmission' })
      this.sendMissionEvent('create-mission', {
        typeName: 'ConstellationSimulationRequest'
      })
    },
    redirectToSimulator() {
      this.$router.push({ path: '/numericalsimulatormission' })
      this.sendMissionEvent('create-mission', {
        type: 'Simulator',
        typeName: 'SimulationRequest'
      })
    },
    redirectToManeuverRestitution() {
      this.$router.push({ path: '/maneuverrestitutionrequest' })
      this.sendMissionEvent('create-mission', {
        type: 'Maneuver Restitution',
        typeName: 'ManeuverRestitutionRequest'
      })
    },
    redirectToManeuverAnalysis() {
      this.$router.push({ path: '/maneuveranalysisrequest' })
      this.sendMissionEvent('create-mission', {
        type: 'Maneuver Analysis',
        typeName: 'ManeuverCatalogueAnalysisRequest'
      })
    },
    redirectToDataGenerator() {
      this.$router.push({ path: '/datageneratorrequest' })
      this.sendMissionEvent('create-mission', {
        type: 'Data Generator',
        typeName: 'DataGeneratorRequest'
      })
    },
    redirectToScreeningCatalogueAnalysis() {
      this.$router.push({
        path: '/screeningcatalogueanalysisreactivedashboard'
      })
      this.sendMissionEvent('create-mission', {
        type: 'Screening',
        typeName: 'ScreeningCatalogueAnalysisRequest'
      })
    },
    redirectToEvasiveManeuver() {
      this.$router.push({ path: '/evasivemaneuverrequest' })
      this.sendMissionEvent('create-mission', {
        type: 'Evasive Maneuver',
        typeName: 'EvasiveManeuverRequest'
      })
    },
    createNewMission() {
      let mission = {
        type: this.missionType,
        typeName: missionTools.moduleTypenameMapping[this.module]
      }
      this.missionType = null
      this.module = null

      this.redirectToMissionSetting(mission.typeName)
      this.sendMissionEvent('create-mission', mission)
    },
    redirectToMissionSetting(typeName) {
      this.$router.push({
        path: '/' + missionTools.missionUrlMapping[typeName].settings
      })
    },
    sendMissionEvent(eventName, mission) {
      // event send to root because it should be treated by sub components
      // use nextTick to be sure mission components are created and can handle events
      Vue.nextTick(() => {
        this.$root.$emit(eventName, mission)
      })
    }
    // ----------------------------------------------------------------------------------
  }
}
</script>

<style scoped>
.headline {
  overflow: hidden;
  width: 90%;
  text-align: center;
}

.headline span:before,
.headline span:after {
  background-color: #9e9e9e;
  content: '';
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
}

.headline span:before {
  right: 0.5em;
  margin-left: -50%;
}

.headline span:after {
  left: 0.5em;
  margin-right: -50%;
}

.flexcard {
  display: flex;
  flex-direction: column;
}

.subtitle {
  display: flex;
  justify-content: center;
}
</style>
